export default "__VITE_ASSET__VN0sGexq__"